import { IUsageGroupState } from "../../redux/types/IUsageGroupState";
import { IValidationMessage } from "../../repertoire/types/IValidationMessage";
import IMembersPortalComponentDataItem from "../../redux/types/IMembersPortalComponentDataItem";
import { adjustProgramDates, isInvalidDateTimeRange, timeToMinutes } from "../../util/tools";

export class MembersPortalLivePerformanceValidator {

    public static validateLivePerformance(usage: IUsageGroupState, livePerformanceMaintenanceGeneralDataViewData: IMembersPortalComponentDataItem): IValidationMessage[] {
        let livePerformanceIsValid: IValidationMessage[];
        livePerformanceIsValid = [];
        let fields = livePerformanceMaintenanceGeneralDataViewData?.fields;
        if (Boolean(usage.fullPerformer) === false) {
            livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformancePerformerNotSet")?.data :  "Performer field cannot be empty"})
        }
        if (Boolean(usage.location) === undefined) {
            livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceVenueNotSet")?.data : "Please enter valid Venue" })
        }
        if (Boolean(usage.venueDetails.firstName) === false) {
            livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceFirstNameNotSet")?.data : "Firstname field cannot be empty" })
        }
        if (Boolean(usage.venueDetails.lastName) === false) {
            livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceLastNameNotSet")?.data : "Lastname field cannot be empty" })
        }
        if (Boolean(usage.venueDetails.phoneNumber) === false) {
            livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceContactNumberNotSet")?.data : "Contact number field cannot be empty" }) 
        }
        if (Boolean(usage.venueDetails.venueType) === false) {
            livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceVenueTypeNotSet")?.data : "Venue type field cannot be empty" })
        }
        if (Boolean((usage.livePerformanceSetList)) === false) {
            livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceSetlistAvailable")?.data : "Please select Setlist available" })
        }
        if (!usage.location && !usage.venueDetails.venueCode && !usage.venueDetails.venueName) {
            livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceVenuefieldNotSet")?.data : "Venue field cannot be empty" })
        }
        if (usage.files.length===0) {
              livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformancePerformanceProofNotSet")?.data : "Proof of Performance field cannot be empty" })
        }
        usage.usages.map(element => {
            if (!element.usageDate?.value) {
                livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceInvalidPerformanceDate")?.data : "Please enter valid Performance date" })
            }
            if (!element.programStartDate?.value) {
                livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceInvalidStartDate")?.data : "Please enter valid Start time" })
            }
            if (!element.programEndDate?.value) {
                livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceInvalidEndDate")?.data : "Please enter valid End time" })
            }
            if (element.programStartDate?.value && element.programEndDate?.value && isInvalidDateTimeRange(element.programStartDate.value, element.programEndDate.value)) {
                livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceFromDateAfterToDate")?.data : "Start date and time cannot be later than or equal to end date and time." });
            }
        });

        let moreDatesInvalidPerformanceDate = false;
        let moreDatesInvalidPerformanceEndDate = false;
        let moreDatesInvalidStartTime = false;
        let moreDatesInvalidEndTime = false;
        let moreDatesInvalidTimeRange = false;

        usage.moreDates?.forEach(element => {

            const usageDate = element.usageDate?.value;
            const usageEndDate = element.usageEndDate?.value;
            const programStartDate = element.programStartDate?.value;
            const programEndDate = element.programEndDate?.value;
            const spansTwoDates = element.spansTwoDates?.value === true;

            if (!usageDate) {
                moreDatesInvalidPerformanceDate = true;
            }
            if (spansTwoDates && !usageEndDate) {
                moreDatesInvalidPerformanceEndDate = true;
            }
            if (!programStartDate) {
                moreDatesInvalidStartTime = true;
            }
            if (!programEndDate) {
                moreDatesInvalidEndTime = true;
            }
            if (usageDate && programStartDate && programEndDate && (!spansTwoDates || usageEndDate)) {
                const effectiveEndDate = spansTwoDates ? usageEndDate : usageDate;
                const adjustedDates = adjustProgramDates(
                    programStartDate,
                    programEndDate,
                    usageDate,
                    effectiveEndDate
                );
                if (!adjustedDates || adjustedDates.startDate >= adjustedDates.endDate
                ) {
                    moreDatesInvalidTimeRange = true;
                }
            }
        });

        if (moreDatesInvalidPerformanceDate) {
            livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceMoreDatesInvalidPerformanceDate")?.data : "At least one record in More Dates has an invalid performance date" });
        }
        if (moreDatesInvalidPerformanceEndDate) {
            livePerformanceIsValid.push({messageKey: fields ? fields.find(field => String(field.name) === "saveValidationDraftLivePerformanceMoreDatesInvalidPerformanceEndDate")?.data : "At least one record in More Dates has an invalid performance end date"
            });
        }
        if (moreDatesInvalidStartTime) {
            livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceMoreDatesInvalidStartDate")?.data : "At least one record in More Dates has an invalid start time" });
        }
        if (moreDatesInvalidEndTime) {
            livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceMoreDatesInvalidEndDate")?.data : "At least one record in More Dates has an invalid end time" });
        }
        if (moreDatesInvalidTimeRange) {
            livePerformanceIsValid.push({ messageKey: fields ? fields.find((field) => String(field.name) === "saveValidationDraftLivePerformanceMoreDatesFromDateAfterToDate")?.data : "At least one record in More Dates has a start time later than or equal to the end time" });
        }

        return livePerformanceIsValid;
    }
}